import React, { Component } from 'react';
import SERVER_URL from '../Global';
import { Affix, Breadcrumb, Icon, Popover, Card } from 'antd';
import { Container, Row, Col } from 'reactstrap';
import { Select, Input } from 'antd';
import { Link } from 'react-router-dom';

const { Option } = Select;

export class CompanyCategoryList extends Component {
    static displayName = CompanyCategoryList.name;

    constructor(props) {
        super(props);
        this.state = {
            companycategories: [],
            loading: true,
            top: 10,
            orderBy: 'name',
            order: 1,
            searchName: null,
            detailCompanyCategory: [],
            loadingDetail: true,
            newCompName: '',
            categories: [],
            SelectedCompanyCategories: '',
            user: this.props.token,
            pageNumber: 1,
            maxPageSize: 1,
            catInOrder : [],
        };

        document.title = "Polar - Categories"

        this.handleNameChange = this.handleNameChange.bind(this);
        this.editName = this.editName.bind(this);
        this.handleCat = this.handleCat.bind(this);
        this.editConfirm = this.editConfirm.bind(this);
        this.catReload = this.catReload.bind(this);
        this.infiniteScroll = this.infiniteScroll.bind(this);
        this.sortCat = this.sortCat.bind(this);
        this.getDetail = this.getDetail.bind(this);

        fetch(
            `${SERVER_URL + 'api/companycategory/listWithSons'}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "name": this.state.searchName,
                    "page": 1,
                    "totalPages": 0,
                    "totalItems": 0,
                    "pageSize": 25,
                    "pageSizeOptions": null,
                    "ordering": {
                        "orderPropertyName": this.state.orderBy,
                        "order": this.state.order
                    },
                    "firstItemNumber": 0,
                    "lastItemNumber": 0,
                    "entityId": 0
                })
            }
        ).then(response => response.json())
            .then(res => {
                if (res.data != null) {
                    this.setState({ companycategories: res.data, loading: false, maxPageSize: res.params.totalPages }, this.sortCat);
                    if (this.state.order === undefined) {
                        this.setState({ order: '1' });
                    }

                    if (this.state.orderBy === undefined) {
                        this.setState({ orderBy: ' ' });
                    }

                    if (this.state.searchName === undefined) {
                        this.setState({ searchName: ' ' });
                    }
                } else {
                    this.setState({ companycategories: [], loading: false });
                }
            })
    };

    catReload (orderBy, order){
        this.setState({ loading: true });

        fetch(
            `${SERVER_URL + 'api/companycategory/listWithSons?lang=en'}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "name": this.state.searchName,
                    "page": 1,
                    "pageSize": 25,
                    "ordering": {
                        "orderPropertyName": orderBy,
                        "order": order
                    }
                })
            }
        ).then(response => response.json())
            .then(res => {
                if (res.data != null) {
                    this.setState({ companycategories: res.data, loading: false, order: order, orderBy: orderBy, maxPageSize: res.params.totalPages }, this.sortCat);
                } else {
                    this.setState({ companycategories: [], loading: false, order: order, orderBy: orderBy, maxPageSize: 1 });
                }
            })
    }

    getDetail(catId) {
        this.closeEdit();
        fetch(`${SERVER_URL + 'api/companycategory/' + catId}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.state.user}`
            },
        }).then(response => response.json())
            .then(res => {
                this.setState({ detailCompanyCategory: res.data, loadingDetail: false, newCompName: res.data.name });
            });
    }

    editConfirm(catId, parentId) {
        fetch(`${SERVER_URL + 'api/companycategory'}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.state.user}`
            },
            body: JSON.stringify({
                'name': `${this.state.newCompName}`,
                'catId': `${catId}`,
                "CompanyCategoryParentCatId": parentId,
                "status": 1
            })
        }).then(fun => {
            this.setState({ loading: true })

            fetch(
                `${SERVER_URL + 'api/companycategory/listWithSons'}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "name": this.state.name,
                        "page": 1,
                        "totalPages": 0,
                        "totalItems": 0,
                        "pageSize": 25,
                        "pageSizeOptions": null,
                        "ordering": {
                            "orderPropertyName": this.state.orderBy,
                            "order": this.state.order
                        },
                        "firstItemNumber": 0,
                        "lastItemNumber": 0,
                        "entityId": 0
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    this.setState({ companycategories: res.data, loading: false, maxPageSize: res.params.totalPages }, this.sortCat);
                }).then(func => {
                    this.closeDetail();
                    this.getDetail(catId);

                    var element = document.getElementById(catId + 'row');
                    element.classList.add("newlyAdded");
                    window.setTimeout(function () {
                        element.classList.add("newlyRemoved");
                        element.classList.remove("newlyAdded");
                    }, 1500)
                    window.setTimeout(function () {
                        element.classList.remove("newlyRemoved");
                    }, 3500)
                })
        });
    }

    detailEdit() {
        this.setState({ catEdit: true })
    }

    closeEdit() {
        this.setState({ catEdit: false})
    }

    getFiles(files) {
        this.setState({ portraitImage: files.base64 })
    }

    handleNameChange(event) {
        this.setState({ searchName: event.target.value });
        if (event.target.value.length > 1 || event.target.value.length == 0) {
            this.setState({loading:true})
            fetch(
                `${SERVER_URL + 'api/companycategory/listWithSons'}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "name": event.target.value,
                        "page": 1,
                        "totalPages": 0,
                        "totalItems": 0,
                        "pageSize": 25,
                        "pageSizeOptions": null,
                        "excludeSons": false,
                        "ordering": {
                            "orderPropertyName": this.state.orderBy,
                            "order": this.state.order
                        },
                        "firstItemNumber": 0,
                        "lastItemNumber": 0,
                        "entityId": 0
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    if (res.data) {
                        this.setState({ companycategories: res.data, loading: false, maxPageSize: res.params.totalPages, pageNumber: 1 }, this.sortCat);
                    }
                    else {
                        this.setState({ companycategories: [], loading: false, pageNumber: 1 });
                    }
                })
        }
    }

    infiniteScroll(e) {
        //qua lascio alcuni pixel di incertezza per scrollare
        const fondo = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 2;
        if (fondo && this.state.maxPageSize > this.state.pageNumber && !this.state.loadingBelow) {
            let newPage = this.state.pageNumber + 1
            this.setState({ loadingBelow: true });
            fetch(
                `${SERVER_URL + 'api/companycategory/listWithSons'}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "name": this.state.searchName,
                        "page": newPage,
                        "pageSize": 25,
                        "ordering": {
                            "orderPropertyName": this.state.orderBy,
                            "order": this.state.order
                        },
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    if (res.data != null && newPage <= res.params.totalPages) {
                        let cat = this.state.companycategories.concat(res.data);
                        this.setState({ companycategories: cat, pageNumber: newPage, loadingBelow: false }, this.sortCat);
                    } else {
                        this.setState({ loadingBelow: false})
                    }
                })
        }
    }

    editName(event) {
        this.setState({ newCompName: event.target.value });
    }

    handleCat(value) {
        this.setState({ SelectedCompanyCategories: value });
    }

    closeDetail() {
        this.closeEdit();
        this.setState({ loadingDetail: true });
    }

    sortCat() {       
        //category ordering
        let categories = [];
        //tutte le cat senza parentId
        let sons = [];
        //tutti i parent
        let parents = [];

        console.log(this.state.companycategories);

        this.state.companycategories.sort(function (a, b) {
            if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
            if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
            return 0;
        }).map(cat => {
            if (cat.companyCategoryParentCatId == null) {
                parents.push(cat.catId);
                categories.push(cat);

                if (cat.companyCategorySons) {
                    cat.companyCategorySons.map(son => {
                        categories.push(son);
                    });
                }
            } else {
                sons.push(cat);
            }
        });

        //se una figlia (con parentId) non ha il parent nell'array parents, aggiungila alla lista, in fondo.
        sons.map(son => {
            if (parents.indexOf(son.companyCategoryParentCatId) == -1) {
                categories.push(son);
            }
        });

        //fine category ordering
        
        this.setState({ catInOrder: categories })
    }

    render() {

        this.state.categories.map(cat =>
            <Option key={cat.catId}>{cat.name}</Option>
        )

        let iniziale = this.state.detailCompanyCategory.name ? this.state.detailCompanyCategory.name.charAt(0) : ""

        let immmagine = <div className="fakeImageHr">{iniziale}</div>

        let created = this.state.detailCompanyCategory.created ? this.state.detailCompanyCategory.created.slice(8, 10) + "/" + this.state.detailCompanyCategory.created.slice(5, 7) + "/" + this.state.detailCompanyCategory.created.slice(0, 4) + " (" + this.state.detailCompanyCategory.created.slice(11, 16) + ")" : null

        let lastUpdate = this.state.detailCompanyCategory.lastUpdate ? this.state.detailCompanyCategory.lastUpdate.slice(8, 10) + "/" + this.state.detailCompanyCategory.lastUpdate.slice(5, 7) + "/" + this.state.detailCompanyCategory.lastUpdate.slice(0, 4) + " (" + this.state.detailCompanyCategory.lastUpdate.slice(11, 16) + ")" : null

        let contentsDetail = this.state.loadingDetail ? null :
            <div className="row detail cardDetailData">
                <Card className="catDetail" style={{ width: 'calc(47vh - 15px)', marginLeft:'15px' }} actions={[<Link to={"/modifycat?catId=" + this.state.detailCompanyCategory.catId} ><Popover content="Edit"><Icon type="edit" /></Popover></Link>]}>
                    {immmagine}
                    <h3 style={{ marginBottom: '0px', fontSize:'24px', marginTop:'10px' }}>{this.state.detailCompanyCategory.name}</h3>

                    <hr style={{ borderColor: "gray", marginTop: '20px', borderTop: '1px solid #b1b5bb' }} />
                    <p><b>Created:</b> {created}</p>
                    <p><b>Last Updated:</b> {lastUpdate}</p>
                            
                </Card >
            </div>        

        let tableContent = this.state.loading ?
            <tr className="spinContainer">
                <td>
                    <Icon type="loading" style={{ fontSize: 114, color: '#1890ff' }} spin />
                </td>
            </tr>
            : this.state.companycategories.length == 0 ?
                null
                :
                this.state.catInOrder.map(companycategory => {              
                    var parent = null
                    if (companycategory.companyCategoryParent != null) {
                        parent = companycategory.companyCategoryParent.name
                        return (
                            <tr id={companycategory.catId + "row"} key={companycategory.catId}>
                                <td onClick={() => this.getDetail(companycategory.catId)}><p className="catSon">{companycategory.name}</p></td>
                                <td onClick={() => this.getDetail(companycategory.catId)}>{parent}</td>
                            </tr>
                        )
                    } else {
                        return (
                            <tr id={companycategory.catId + "row"} key={companycategory.catId}>
                                <td onClick={() => this.getDetail(companycategory.catId)}>{companycategory.name}</td>
                                <td onClick={() => this.getDetail(companycategory.catId)}></td>
                            </tr>
                        )
                    }               
                })

        let noCat = this.state.companycategories.length == 0 ?
            <div className="noCat">
                <h3>No Categories found</h3>
            </div> : null

        return (
            <Container fluid={true}>
                <Row>
                    <Col sm="12" style={{ display: 'inline-flex', height: '0' }}>
                        <Breadcrumb className="bread">
                            <Breadcrumb.Item>Categories</Breadcrumb.Item>
                        </Breadcrumb>
                        <div className="plusButtonCat">
                            <a style={{ marginRight: '10px' }} className="button create" href="/category/create" ><Icon type="plus" /></a>
                        </div>

                        <div className="ant-breadcrumb searchList cat midSearchBar">
                            <Input autoComplete="new-password" placeholder="Search Categories" style={{ width: '100%', marginTop: '-1em' }} allowClear={true} value={this.state.searchName} onChange={this.handleNameChange} />

                            <Icon className="homeViewSearch" onClick={this.handleFilters} type="search" />
                        </div>
                    </Col>

                    <Col sm="9" onScroll={this.infiniteScroll} className="mainBoard">
                        <div className="tableContainer">
                            <table className='table table-striped'>
                                <thead>
                                    <tr>
                                        <th>Name<Icon type="down" onClick={() => this.catReload("name", 1)} /><Icon type="up" onClick={() => this.catReload("name", -1)} /></th>
                                        <th>Parent Category</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tableContent}
                                </tbody>                                
                            </table>
                            {noCat}
                        </div>
                    </Col>
                    <Col sm="3">
                        <Affix offsetTop={this.state.top}>
                            <div className="inner">
                                {contentsDetail}
                            </div>
                        </Affix>
                    </Col>
                </Row>
            </Container>
        );
    }
}


// WEBPACK FOOTER //
// ./src/CompanyCategory/CompanyCategoryIndexGET.js